import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';

class ViewValidationModal extends Component {
  static propTypes = {
    validation: PropTypes.object,
    onHide: PropTypes.func,
    show: PropTypes.bool,
  };

  render() {
    const { onHide, validation, show } = this.props;

    return (
      <Modal show={show} onHide={onHide} title="Validation">
        <form>
          <Modal.Body className="px-5">
            <div>
              <strong>Supervisor Email:</strong> {validation.supervisorEmail}
            </div>
            <div>
              <strong>Start Date:</strong> {validation.start}
            </div>
            <div>
              <strong>End Date:</strong> {validation.start}
            </div>
            <div>
              <strong>Hours:</strong> {validation.hours}
            </div>
            <div>
              <strong>Description:</strong> {validation.description}
            </div>
            <div>
              <strong>Satisfaction:</strong> {validation.satisfaction}
            </div>
            <div>
              <strong>Comments:</strong> {validation.comments}
            </div>
            <div>
              <strong>Signature:</strong> {validation.signature}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default ViewValidationModal;
